module.exports = __webpack_public_path__ + "img/undraw_proud_coder_7ain.d8351408.png";